import PropertyAssetsControlPage from "./PropertyAssetsControlPage";
import { PROPERTY_ASSETS_SUBMODULE_SLUG } from "../utils/propertyAssetPermissionSlugs";

export default function PropertyAssetsSubAdminPage() {
  return <PropertyAssetsControlPage screenSlug={PROPERTY_ASSETS_SUBMODULE_SLUG} />;
}
